//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <svg
    width="14"
    height="4"
    viewBox="0 0 14 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.166626 3.53373V0.75H13.8854V3.53373H0.166626Z"
      :style="{ fill: store.state.Style.themeColor }"
    />
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
